/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, number, string } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import LinearProgress from '@material-ui/core/LinearProgress';

const styles = (theme) => ({
    cyoProgressBar: {
        flexGrow: 1,
        display: 'block',
        fontFamily: theme.typography.fontFamily,
    },
    progressBar: {
        paddingBottom: '10px',
        position: 'relative',
    },
    progressBarRoot: {
        height: '30px',
        borderRadius: '16px',
        backgroundColor: theme.palette.cms?.cyoProgressBarBg || '#666666',
        [theme.breakpoints.down('xs')]: {
            height: '8px',
            borderRadius: '4px',
            backgroundColor: theme.palette.grey7 || '#e3e3e3',
        },
    },
    progressBarPrimColor: {
        backgroundColor: theme.palette.primaryButton || '#a1001a',
        [theme.breakpoints.down('xs')]: {
            backgroundColor: theme.palette.cms?.cyoMobileProgressBar || '#24a148',
        },
    },
    selectMore: {
        padding: '3px 0',
    },
    totalCountDisplay: {
        position: 'absolute',
        top: '4px',
        left: '73px',
        zIndex: '1',
        color: theme.palette.white || '#fff',
        fontWeight: '800',
        [theme.breakpoints.down(959)]: {
            left: '50px',
        },
    },
    mobileTotalCountDisplay: {
        color: theme.palette.black || '#1f1f1b',
        marginLeft: '10px',
    },
});

const CYOProgressBar = ({
    classes, valueBufferBar, totalProductSelected, maxComponents, displayView,
}) => (
    <div className={classes.cyoProgressBar}>
        <div className={classes.progressBar}>
            <span className={classes.totalCountDisplay}>
                {displayView === 'desktop'
                    && (
                        `${totalProductSelected}/${maxComponents}`
                    )}
            </span>
            <LinearProgress
                classes={{
                    root: classes.progressBarRoot,
                    barColorPrimary: classes.progressBarPrimColor,
                }}
                variant="determinate"
                value={valueBufferBar}
            />
            <span className={classes.mobileTotalCountDisplay}>
                {displayView === 'mobile'
                && (
                    `${totalProductSelected} of ${maxComponents} Selected`
                )}
            </span>
        </div>
    </div>
);

CYOProgressBar.propTypes = {
    classes: object.isRequired,
    valueBufferBar: number,
    totalProductSelected: number,
    maxComponents: number,
    displayView: string,
};
CYOProgressBar.defaultProps = {
    valueBufferBar: 0,
    totalProductSelected: 0,
    maxComponents: null,
    displayView: 'desktop',
};

export default withStyles(styles)(CYOProgressBar);
